import React from "react";

/**
 * Phase 8 — Goodwin Resolve wordmark.
 * Renders "Goodwin" in Playfair (display serif) + "RESOLVE" in Inter
 * ExtraBold uppercase tracking-wide. Two color schemes:
 *  - "navy"  → for use on white/light backgrounds
 *  - "white" → for use on the navy sidebar
 */
export default function ResolveWordmark({ size = "md", scheme = "navy", className = "" }) {
  const SIZES = {
    sm: { goodwin: "text-base", resolve: "text-[11px] tracking-[0.18em]" },
    md: { goodwin: "text-2xl", resolve: "text-sm tracking-[0.16em]" },
    lg: { goodwin: "text-4xl", resolve: "text-lg tracking-[0.18em]" },
    xl: { goodwin: "text-5xl", resolve: "text-xl tracking-[0.20em]" },
  };
  const s = SIZES[size] || SIZES.md;
  const goodwinColor = scheme === "white" ? "text-white" : "text-brand-navy";
  const resolveColor = scheme === "white" ? "text-[#84C170]" : "text-brand-green";
  return (
    <span
      className={`inline-flex items-baseline gap-2 leading-none ${className}`}
      data-testid="resolve-wordmark"
    >
      <span
        className={`font-serif font-bold ${s.goodwin} ${goodwinColor}`}
        style={{ letterSpacing: "-0.005em" }}
      >
        Goodwin
      </span>
      <span
        className={`font-sans font-extrabold uppercase ${s.resolve} ${resolveColor}`}
      >
        Resolve
      </span>
    </span>
  );
}
